<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <!-- <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div> -->
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                
                <div class="card-body-6 d-flex justify-content-center">
  <form role="form" 
        @submit.stop.prevent="sendData"
        class="w-100 text-center"
        style="max-width: 400px;">

    <div class="pb-0 card-header text-center">
      <h4 class="font-weight-bolder">Ingreso</h4>
    </div>

    <div class="row justify-content-center">
      
      <div class="col-12 mb-3">
        <label class="form-control-label">Usuario</label>
        <argon-input type="text" v-model="model.usuario" />
      </div>

      <div class="col-12 mb-3">
        <label class="form-control-label">Password</label>
        <argon-input type="password" v-model="model.password" />
      </div>

    </div>

    <argon-button
      size="sm"
      class="bg-gray mt-3"
      type="submit"
    >
      Entrar
    </argon-button>

  </form>
</div>
                
              </div>
            </div>
            <div
  class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
>
  <div
    class="position-relative px-3 d-flex flex-column justify-content-center align-items-center"
  >
  <!-- Imagen debajo del título -->
    <img 
      :src="imageUrl"
      class="img-fluid mt-2"
      style="max-width: 300px; height: auto;"
      alt="Logo"
    />
    
    <h2 class="mt-5 text-success font-weight-bolder">
      Plugin Pagos
    </h2>

    

  </div>
</div>
            
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script setup>
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
// import Navbar from "@/examples/PageLayout/Navbar.vue";
// import ArgonSwitch from "@/components/ArgonSwitch.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
  localStorage.clear();
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});
</script>
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import usuario from "../api/usuario";
import Swal from "sweetalert2";
export default {
  created() {
    // Set an item in localStorage when the component is created
   localStorage.removeItem('token');
   localStorage.removeItem('mode');
   localStorage.removeItem('tipo');
  },
  data() {
    return {
      imageUrl: require("../assets/img/pluginLogo.png"), // Utiliza require para importar imágenes en Vue.js
      model:{
        usuario:"",
        password:""
      }
    };
  },
  methods: {
    sendData() {
      usuario
        .logIn(this.model)
        .then((result) => {
          console.log(result.data.log)
          if (result.data.log) {
            Swal.fire({
              title: "Login Correcto",
              text: "Login correcto",
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            localStorage.setItem("token",result.data.log)
            localStorage.setItem("tipo",result.data.tipo)
            localStorage.setItem("mode",result.data.mode)
            this.$router.push({ path: "/Dashboard" });
          } else {
            Swal.fire({
              title: "Error de Ingreso Pagos",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.model.usuario = "";
      this.model.password = "";
    },
    goto() {
      this.$router.push({ path: "/registro" });
    },
  },
};
</script>
